import React, {createContext} from "react";

export const utahHeaderContextValue = {
	utahHeader: null,
};

const UtahHeaderContext = createContext(utahHeaderContextValue);
UtahHeaderContext.displayName = 'UtahHeaderContext';
export default UtahHeaderContext;
